import { AdministrativeCostsData } from './AdministrativeCostsData';
import { ROUND } from './Formatters';
import { InputValue } from './data';

export class TCOData {
  data = 1000;
  supportRate = 12;
  dataFootPrintSavingsPCT = 33;
  supportRateIBM = 6.9;

  annualDataCost!: number;
  annualSupportMaint!: number;
  powerCooling!: number;
  totalAdminCosts!: number;

  annualDataCostIBM!: number;
  annualSupportMaintIBM!: number;
  powerCoolingIBM!: number;
  totalAdminCostsIBM!: number;

  TCO!: number;
  TCOIBM!: number;
  TCOSavings!: number;
  pctTCO!: number;

  public Calculate = (
    inputValue: InputValue,
    administrativeData: AdministrativeCostsData,
  ) => {
    this.data = inputValue.usableCapacity;
    const avgCostTB = inputValue.maturityValue;

    this.annualDataCost = this.data * avgCostTB;
    this.annualSupportMaint = (this.annualDataCost * this.supportRate) / 100;
    this.powerCooling = this.annualDataCost * 0.1 * (5 / 3);
    this.totalAdminCosts = administrativeData.adminCost.totalAdminCosts;

    const dataIBM = this.data * (1 - this.dataFootPrintSavingsPCT / 100);

    this.annualDataCostIBM = dataIBM * avgCostTB;
    this.annualSupportMaintIBM =
      (this.annualDataCostIBM * this.supportRateIBM) / 100;
    this.powerCoolingIBM = this.annualDataCostIBM * 0.1 * (5 / 3);
    this.totalAdminCostsIBM = administrativeData.adminCost.totalAdminCostsIBM;

    //Not used in any calculation
    // let annualDataSavings = this.annualDataCost-this.annualDataCostIBM

    this.TCO =
      this.annualDataCost +
      this.annualSupportMaint +
      this.powerCooling +
      this.totalAdminCosts;
    this.TCOIBM =
      this.annualDataCostIBM +
      this.annualSupportMaintIBM +
      this.powerCoolingIBM +
      this.totalAdminCostsIBM;

    this.TCOSavings = this.TCO - this.TCOIBM;
    this.pctTCO = (this.TCOSavings / this.TCO) * 100;
  };

  get expectedTCOCost() {
    return {
      annualDataCost: ROUND(this.annualDataCost),
      annualSupportMaint: ROUND(this.annualSupportMaint),
      powerCooling: ROUND(this.powerCooling),
      totalAdminCosts: ROUND(this.totalAdminCosts),
    };
  }

  get expectedTCOCostIBM() {
    return {
      annualDataCostIBM: ROUND(this.annualDataCostIBM),
      annualSupportMaintIBM: ROUND(this.annualSupportMaintIBM),
      powerCoolingIBM: ROUND(this.powerCoolingIBM),
      totalAdminCostsIBM: ROUND(this.totalAdminCostsIBM),
    };
  }
  get savingsValue() {
    return {
      TCO: ROUND(this.TCO),
      TCOIBM: ROUND(this.TCOIBM),
      TCOSavings: ROUND(this.TCOSavings),
      pctTCO: ROUND(this.pctTCO),
    };
  }
}
